import React, { useState } from 'react'

interface AuthModalProps {
  isOpen: boolean
  onClose: () => void
  onAuth: (user: any) => void
}

const AuthModal: React.FC<AuthModalProps> = ({ isOpen, onClose, onAuth }) => {
  const [isSignUp, setIsSignUp] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [zipCode, setZipCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  if (!isOpen) return null

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    try {
      // Mock authentication
      await new Promise(resolve => setTimeout(resolve, 1000))
      
      const mockUser = {
        id: '1',
        email,
        zipCode: isSignUp ? zipCode : undefined,
        isPremium: false
      }
      
      onAuth(mockUser)
      onClose()
    } catch (err) {
      setError('Authentication failed. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        zIndex: 1000
      }}
      onClick={onClose}
    >
      <div 
        className="card"
        style={{ 
          maxWidth: '400px', 
          width: '100%',
          background: 'white'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <h2 style={{ margin: 0 }}>{isSignUp ? 'Create Your Garden' : 'Welcome Back'}</h2>
          <button 
            className="btn btn-secondary"
            onClick={onClose}
            style={{ padding: '0.5rem 1rem' }}
          >
            ✕
          </button>
        </div>

        <p style={{ color: '#666', marginBottom: '1.5rem' }}>
          {isSignUp 
            ? 'Start planning your garden for free. Get personalized planting dates and recommendations.'
            : 'Sign in to access your garden plans and continue growing.'
          }
        </p>

        {error && (
          <div className="alert alert-error" style={{ marginBottom: '1rem' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              minLength={6}
            />
          </div>

          {isSignUp && (
            <div className="form-group">
              <label>Zip Code</label>
              <input
                type="text"
                value={zipCode}
                onChange={(e) => setZipCode(e.target.value)}
                placeholder="12345"
                maxLength={5}
                required={isSignUp}
              />
              <small style={{ color: '#666' }}>
                We use this to calculate your frost dates and planting calendar.
              </small>
            </div>
          )}

          <button 
            type="submit" 
            className="btn btn-primary"
            style={{ width: '100%', marginTop: '1rem' }}
            disabled={loading}
          >
            {loading ? 'Please wait...' : (isSignUp ? 'Create Free Account' : 'Sign In')}
          </button>
        </form>

        <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
          <p style={{ color: '#666', margin: 0 }}>
            {isSignUp ? 'Already have an account?' : "Don't have an account?"}
            <button 
              onClick={() => setIsSignUp(!isSignUp)}
              style={{ 
                background: 'none', 
                border: 'none', 
                color: '#2d5a27', 
                cursor: 'pointer',
                marginLeft: '0.5rem',
                fontWeight: 500
              }}
            >
              {isSignUp ? 'Sign In' : 'Sign Up'}
            </button>
          </p>
        </div>

        {isSignUp && (
          <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#f5f5f0', borderRadius: '8px' }}>
            <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>
              <strong>Free includes:</strong> 3 gardens, basic calendar, 5 basic plants
            </p>
            <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.9rem', color: '#666' }}>
              <strong>Upgrade anytime:</strong> Unlimited gardens, all features, Garden Planner Solo access
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default AuthModal
